import { CheckmarkCircleFilledIcon, EditIcon, TimeFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { BottomSheet, History } from '@/components'
import { RecordType } from '@/graphql/queries/fieldHistoryLogs/fieldHistoryLogs.queries'
import { useToggle } from '@/hooks'

import { EditScheduledCommunicationTypeForm } from '../ScheduledCommunicationTypeForms/EditScheduledCommunicationTypeForm'

export const ScheduledCommunicationTypeListColumns = (refetchOnSuccess: () => void) => {
  return [
    {
      Header: 'Active',
      accessor: 'active',
      width: 25,
      canResize: false,
      Cell: ({ value }: { value: string }) => {
        return (
          <CheckmarkCircleFilledIcon
            className={`mr-3 ${value ? 'text-green-300' : 'icon-tertiary'}`}
            height={28}
            width={28}
          />
        )
      },
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 40,
      disableSortBy: true,
    },
    {
      Header: 'Time to Send',
      accessor: 'timeToSend',
      width: 40,
      disableSortBy: true,
      Cell: ({ value }: { value: string }) => {
        const time = new Date(`01/01/2000 ${value}`)

        // Format the time with AM or PM
        const formattedTime = time.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        })

        return <div className="flex w-full items-center justify-center">{formattedTime}</div>
      },
    },
    {
      accessor: 'id',
      width: 25,
      canResize: false,
      Cell: ({ value }: { value: string }) => {
        const { isShown: editModalShown, toggle: editModalToggle } = useToggle()
        const { isShown: historyModalShown, toggle: historyModalToggle } = useToggle()

        return (
          <>
            <button
              className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
              onClick={editModalToggle}
              title="Edit Scheduled Communication Type"
            >
              <EditIcon className="text-green-300" width={16} />
            </button>
            <button
              className="mr-2 grid h-5 w-5 items-center justify-center"
              onClick={historyModalToggle}
              title="View History"
            >
              <TimeFilledIcon className="w-5 cursor-pointer text-green-300" />
            </button>
            <BottomSheet isVisible={editModalShown} mobileFullHeight={true} onClose={editModalToggle}>
              <EditScheduledCommunicationTypeForm
                refetchOnSuccess={refetchOnSuccess}
                scheduledCommunicationTypeId={Number(value)}
                toggle={editModalToggle}
              />
            </BottomSheet>
            {historyModalShown ? (
              <BottomSheet isVisible={historyModalShown} mobileFullHeight={true} onClose={historyModalToggle}>
                <History recordId={Number(value)} recordType={RecordType.SCHEDULED_COMMUNICATION_TYPES} />
              </BottomSheet>
            ) : null}
          </>
        )
      },
    },
  ]
}
